/* Elanessa: announcement bar height -> --rs-announcement-height (the sticky header sits below it).
   Moved out of the inline <script> on 2026-09-03. */
// The header sticks below this bar, so it needs the bar's live height.
  // Marquee height changes with the font-size setting and with wrapping.
  (function () {
    var bar = document.querySelector('.rs-announcement-section');
    if (!bar) return;

    function measure() {
      document.documentElement.style.setProperty(
        '--rs-announcement-height',
        bar.offsetHeight + 'px'
      );
    }

    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    document.addEventListener('shopify:section:load', measure);
    if (typeof ResizeObserver === 'function') new ResizeObserver(measure).observe(bar);
  })();
